import { Card, CardActionArea, GridLegacy as Grid } from "@mui/material";
import { useMsg } from "../../components/Msg/Msg";
import { routes } from "../../routes";
import { useAuth } from "../Authorization";
import { useUserSessionQuery } from "../Sessions/api";
import { useAreasDict } from "../Sessions/areas";
import { sessionsMessages } from "../Sessions/messages";
import { SessionCardIconTile } from "../Sessions/Sessions";

export const AreaAndLongTermGoal = () => {
  const { user } = useAuth();
  const sessionsMsg = useMsg({ dict: sessionsMessages });
  const { areas } = useAreasDict();
  const areaOfDevelopment = user.data.areaOfDevelopment[0];

  const sessionQuery = useUserSessionQuery({
    gcTime: 1000 * 60 * 5,
    retry: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} alignItems="stretch">
        <Card sx={{ height: "100%" }}>
          <CardActionArea
            href={routes.startSession}
            sx={{ minHeight: 92 - 50, p: 3, height: "100%" }}
          >
            <SessionCardIconTile
              grayOutEmpty
              spacious
              iconName={"InsertChart"}
              caption={sessionsMsg("sessions.edit.steps.align.area.caption")}
              text={
                areas[areaOfDevelopment]?.label || areaOfDevelopment
                // dashboardMsg("dashboard.rightmenu.actions.set-area")
              }
            />
          </CardActionArea>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card sx={{ height: "100%" }}>
          <CardActionArea
            href={routes.startSession}
            sx={{ minHeight: 92 - 50, p: 3, height: "100%" }}
          >
            <SessionCardIconTile
              grayOutEmpty
              spacious
              iconName={"Adjust"} // TODO x2
              caption={sessionsMsg("sessions.edit.steps.align.goal.caption")}
              text={sessionQuery.data?.longTermGoal ?? ""}
              isLoading={sessionQuery.isPending}
            />
          </CardActionArea>
        </Card>
      </Grid>
    </Grid>
  );
};
